import __request__ from "routing/request";
export function listNotifications(requestOptions) {
  return __request__("GET", "/system/notifications", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function bulkDelete(NotificationIDstodelete, requestOptions) {
  return __request__("POST", "/system/notifications/bulk/delete", NotificationIDstodelete, {}, {
    "Accept": []
  }, requestOptions);
}
export function getCount(requestOptions) {
  return __request__("GET", "/system/notifications/count", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function deleteNotificationById(id, requestOptions) {
  return __request__("DELETE", `/system/notifications/id/${id}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getPaginated(page = 1, per_page = 50, query, filters, sort = "timestamp", order = "desc", requestOptions) {
  return __request__("GET", "/system/notifications/paginated", null, { "page": page, "per_page": per_page, "query": query, "filters": filters, "sort": sort, "order": order }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function renderHtmlById(id, requestOptions) {
  return __request__("GET", `/system/notifications/${id}/message/html`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function deleteNotification(notificationType, requestOptions) {
  return __request__("DELETE", `/system/notifications/${notificationType}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function deleteKeyedNotification(notificationType, notificationKey, requestOptions) {
  return __request__("DELETE", `/system/notifications/${notificationType}/${notificationKey}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
